import Router from '@netx/core/lib/netx-routers-app';

/**
 * App router instance
 */
export const appRouter = new Router();
appRouter.routes = {};

export default appRouter;
